<ng-container [class.hidden]="!dataSource">
        <mat-card appearance="outlined" class="table-card" style="margin-top: 80px;">
            <span class="d-flex flex-column" style="flex: 1;">
                <div class="compact-table-header">
                    <span></span>

                    <span class="d-flex align-items-center">
                        <!-- search-bar -->
                        <app-search-bar
                            [(customSearchBarConfig)]="searchBarConfig" 
                            (searchAction)="searchUsers()"  
                            [disabled]="noRecord" 
                        ></app-search-bar>

                        <div class="actions d-flex align-items-center">
                            <button
                                mat-icon-button 
                                class="table-filter-trigger mr-4" 
                                [class.opened]="tableFilterOpen" 
                                [class.text-hint]="!noRecord" 
                                (click)="tableFilterOpen = !tableFilterOpen"
                                [disabled]="noRecord"
                            >
                                <mat-icon [matTooltip]="'Filter'">{{noRecord ? 'filter_list_off' : 'filter_list'}}</mat-icon>
                            </button>
                            <div class="vertical-divider ml-10 mr-10" style="height: 32px !important;"></div>
                            <button
                                mat-icon-button 
                                [class.text-hint]="!(noRecord || !hasListFilters)" 
                                (click)="resetAll()"
                                [disabled]="noRecord || !hasListFilters"
                            >
                                <mat-icon [matTooltip]="'Reset'">restart_alt</mat-icon>
                            </button>
                        </div>
                    </span>
                </div>
                
                <app-custom-table-filter 
                    [filterFormOpened]="tableFilterOpen" 
                    [customTableFilterData]="tableFiltersData" 
                    [hasFilter]="hasAnyFilter" 
                    (filterValueChange)="filterTable($event)" 
                    #customTableFiltersComp
                ></app-custom-table-filter>

                
                <div class="table-container" style="flex: 1;position: relative;">
                    <!-- Table -->
                    <table 
                        mat-table 
                        [dataSource]="dataSource" 
                        class="mat-elevation-z8" 
                        matSort 
                        [matSortActive]="currentSort.active"
                        matSortDisableClear 
                        [matSortDirection]="currentSort.direction" 
                        [ngClass]="{ 'disabled-table': noRecord }" 
                        [matSortDisabled]="noRecord" 
                        #sort
                    >
                        <ng-container *ngFor="let colData of componentData.dataColumns">
                            <ng-container *ngIf="colData['contentType'] == 'status'; else textColumnTemp">
                                <!-- Status Column -->
                                <ng-container [matColumnDef]="colData.value">
                                    <th 
                                        mat-header-cell 
                                        *matHeaderCellDef 
                                        mat-sort-header
                                        [disabled]="!colData.hasSort" 
                                        [class]="colData.headerClasses"
                                    >{{colData.name}}</th>
                                    <td mat-cell *matCellDef="let data" [class]="colData.descriptionClasses">
                                        <div 
                                            *ngIf="data[colData.value] as _statusData"
                                            style="margin: 0px auto !important" 
                                            [class]="'text-badge ' + _statusData.class" 
                                            [matTooltip]="_statusData.value" 
                                            >
                                            <div class="mat-caption m-0">{{_statusData.value | uppercase}}</div>
                                        </div>
                                    </td>
                                </ng-container>
                            </ng-container>

                            <ng-template #textColumnTemp>
                                <!-- Text Column -->
                                <ng-container [matColumnDef]="colData.value">
                                    <th 
                                        mat-header-cell 
                                        *matHeaderCellDef 
                                        mat-sort-header
                                        [disabled]="!colData.hasSort" 
                                        [class]="colData.headerClasses" 
                                    >{{colData.name}}</th>
                                    <td 
                                        mat-cell 
                                        *matCellDef="let data" 
                                        [class]="colData.descriptionClasses" 
                                        [matTooltip]="data[colData.value] ?? ''" 
                                        [matTooltipShowDelay]="tooltipDelay" 
                                    >{{ data[colData.value] }}</td>
                                </ng-container>
                            </ng-template>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr
                            mat-row
                            class="row-hover" 
                            *matRowDef="let row; columns: displayedColumns"
                        ></tr>
                    </table>

                    <!-- Row shown when there is no matching data. -->
                    <div *ngIf="recordLength === 0 && !noRecord" class="table-message">
                        <section style="text-align: center;width: 450px !important;">
                            <h6>{{customTableListInfos.noRecordLengthTitle}}</h6>
                            <div class="mat-body-2 text-hint">{{customTableListInfos.noRecordLengthDesc}}</div>
                        </section>
                    </div>
    
                    <div *ngIf="noRecord" class="table-message">
                        <section style="text-align: center;width: 400px !important;">
                            <h6>{{customTableListInfos.noRecordTitle}}</h6>
                            <div class="mat-body-2 text-hint">{{customTableListInfos.noRecordDesc}}</div>
                        </section>
                    </div>
                </div>
            </span>

            <mat-paginator
                [ngClass]="{ hidden: noRecord }"
                #paginator
                [length]="recordLength"
                [pageSizeOptions]="currentPaginateSizes"
                aria-label="paginate the list"
            ></mat-paginator>
        </mat-card>
</ng-container>
